import { observer } from 'mobx-react'
import TariffsContent from '../TariffsContent'
import Tariffs from '../Tarrifs'

const TariffsCol = observer(() => {
  return (
    <section className="tariffs-col">
      <Tariffs />
      <TariffsContent />
    </section>
  )
})

export default TariffsCol
